export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('hot-key', (el: HTMLElement, binding: any) => {
    const keys = useMagicKeys()
    const hotKey = keys[binding.value]

    whenever(hotKey, () => el.focus())
  })
})
